import type { Move, PlayedMove, RoundOutcome } from '../protocol';

export const MOVE_EMOJI: Record<PlayedMove, string> = {
  rock: '🪨',
  paper: '📃',
  scissors: '✂️',
  timeout: '⏰',
};

export function moveEmoji(move: PlayedMove | string): string {
  return MOVE_EMOJI[move as PlayedMove] ?? '❓';
}

interface MoveButtonSpec {
  move: Move;
  emoji: string;
  label: string;
}

export const MOVE_BUTTONS: readonly MoveButtonSpec[] = [
  { move: 'rock', emoji: MOVE_EMOJI.rock, label: 'ROCK' },
  { move: 'paper', emoji: MOVE_EMOJI.paper, label: 'PAPER' },
  { move: 'scissors', emoji: MOVE_EMOJI.scissors, label: 'SCISSORS' },
];

interface OutcomeSpec {
  title: string;
  symbol: string;
  /** CSS modifier suffix — drives colours in app.css. */
  tone: 'win' | 'loss' | 'tie';
}

const OUTCOMES: Record<RoundOutcome, OutcomeSpec> = {
  WIN: { title: 'WIN', symbol: '✅', tone: 'win' },
  LOSS: { title: 'LOSS', symbol: '❌', tone: 'loss' },
  TIE: { title: 'TIE', symbol: '⚔️', tone: 'tie' },
  TIMEOUT_LOSS: { title: 'LOSS', symbol: '❌', tone: 'loss' },
};

export function outcomeSpec(result: RoundOutcome | string): OutcomeSpec {
  return OUTCOMES[result as RoundOutcome] ?? { title: String(result), symbol: '❓', tone: 'tie' };
}
